var {AmpersandModel} = require('catalog/libs');

var HTMLLoaderTabModel = AmpersandModel.extend({

    initialize: function() {
        this.content = '';
    },

    props: {
        content: 'string'
    },

    url: 'http://localhost:1313/api/markup',

    ajaxConfig: function() {
        return {
            headers: {
                'Accept': 'text/html; charset=utf-8'
            }
        };
    },

    parse: function(response) {
        return {
            content: response
        };
    }
});

module.exports = HTMLLoaderTabModel;
